const loadImg = (src) => new Promise((res) => {
  if (!src) return res(null);
  const i = new Image();
  i.crossOrigin = "anonymous";
  i.onload = () => res(i);
  i.onerror = () => res(null);
  i.src = src;
});

const fit = (ctx, text, max) => {
  let t = text;
  while (t && ctx.measureText(t).width > max) t = t.slice(0, -1);
  return t === text ? t : `${t.trimEnd()}…`;
};

export async function cardPng({ f, logo, color, qrSvg, ls = 1 }) {
  const S = 12, W = 85 * S, H = 55 * S;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = color; ctx.fillRect(0, 0, 2.2 * S, H);
  const L = 6.7 * S;
  let y = 4.5 * S;
  const img = await loadImg(logo);
  if (img) {
    const s = Math.min((38 * S * ls) / img.width, (15 * S * ls) / img.height);
    ctx.drawImage(img, L, y, img.width * s, img.height * s);
    y += img.height * s;
  } else {
    ctx.beginPath(); (ctx.roundRect ? ctx.roundRect(L, y, 9 * S, 9 * S, 2 * S) : ctx.rect(L, y, 9 * S, 9 * S)); ctx.fill();
    ctx.fillStyle = "#fff"; ctx.font = `800 ${5 * S}px 'Plus Jakarta Sans', sans-serif`; ctx.textAlign = "center";
    ctx.fillText((f.name || "S").slice(0, 1).toUpperCase(), L + 4.5 * S, y + 6.6 * S); ctx.textAlign = "left";
    y += 9 * S;
  }
  const maxW = 49 * S;
  ctx.fillStyle = "#0f172a"; ctx.font = `800 ${3.9 * S}px 'Plus Jakarta Sans', sans-serif`;
  ctx.fillText(fit(ctx, f.name || "", maxW), L, y + 6 * S);
  if (f.title) { ctx.fillStyle = color; ctx.font = `600 ${2.6 * S}px 'DM Sans', sans-serif`; ctx.fillText(fit(ctx, f.title, maxW), L, y + 9.6 * S); }
  const lines = [f.phone && `☎ ${f.phone}`, f.email && `✉ ${f.email}`, f.address && `⌂ ${f.address}`].filter(Boolean);
  ctx.fillStyle = "#334155"; ctx.font = `${2.4 * S}px 'DM Sans', sans-serif`;
  lines.forEach((t, i) => ctx.fillText(fit(ctx, t, maxW), L, H - 4.5 * S - (lines.length - 1 - i) * 3.4 * S));
  const rx = 59.5 * S;
  ctx.strokeStyle = "#cbd5e1"; ctx.setLineDash([S * 0.6, S * 0.8]); ctx.lineWidth = 2;
  ctx.beginPath(); ctx.moveTo(rx, 4.5 * S); ctx.lineTo(rx, H - 4.5 * S); ctx.stroke(); ctx.setLineDash([]);
  const svg = qrSvg.includes("xmlns=") ? qrSvg : qrSvg.replace("<svg", '<svg xmlns="http://www.w3.org/2000/svg"');
  const qr = await loadImg(`data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`);
  if (qr) ctx.drawImage(qr, rx + 2 * S, 14 * S, 22 * S, 22 * S);
  ctx.fillStyle = color; ctx.font = `700 ${2.3 * S}px 'DM Sans', sans-serif`; ctx.textAlign = "center";
  ctx.fillText("Online teklif al", rx + 13 * S, 40 * S);
  return new Promise((res) => c.toBlob(res, "image/png"));
}

const rr = (ctx, x, y, w, h, r) => { ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(x, y, w, h, r); else ctx.rect(x, y, w, h); ctx.fill(); };
const svgImg = (svg) => loadImg(`data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg.includes("xmlns=") ? svg : svg.replace("<svg", '<svg xmlns="http://www.w3.org/2000/svg"'))))}`);
const wrapLines = (ctx, text, max) => {
  const out = []; let line = "";
  (text || "").split(" ").forEach((w) => { const t = line ? `${line} ${w}` : w; if (ctx.measureText(t).width > max && line) { out.push(line); line = w; } else line = t; });
  return line ? [...out, line] : out;
};

export async function storyPng({ f, logo, color, qrSvg, headline, iconSvg = "", bullets = [], ls = 1 }) {
  const W = 1080, H = 1920, tpl = !!iconSvg, k = tpl ? Math.min(ls, 1.2) : ls;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = color; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#ffffff14";
  ctx.beginPath(); ctx.arc(W - 60, 260, 360, 0, Math.PI * 2); ctx.fill();
  ctx.beginPath(); ctx.arc(80, H - 220, 300, 0, Math.PI * 2); ctx.fill();
  ctx.textAlign = "center";
  const img = await loadImg(logo);
  let y = tpl ? 140 : 230;
  if (img) {
    const s = Math.min((560 * k) / img.width, ((tpl ? 200 : 280) * k) / img.height), w = img.width * s, h = img.height * s;
    ctx.fillStyle = "#fff"; rr(ctx, W / 2 - w / 2 - 36, y - 28, w + 72, h + 56, 28);
    ctx.drawImage(img, W / 2 - w / 2, y, w, h);
    y += h + (tpl ? 80 : 130);
  } else {
    ctx.fillStyle = "#fff"; ctx.font = "800 64px 'Plus Jakarta Sans', sans-serif"; ctx.fillText(f.name || "", W / 2, y + 60);
    y += tpl ? 140 : 250;
  }
  if (tpl) {
    ctx.fillStyle = "#fff"; ctx.beginPath(); ctx.arc(W / 2, y + 85, 85, 0, Math.PI * 2); ctx.fill();
    const ic = await svgImg(iconSvg.replace(/currentColor/g, color));
    if (ic) ctx.drawImage(ic, W / 2 - 50, y + 35, 100, 100);
    y += 260;
  }
  ctx.fillStyle = "#fff"; ctx.font = `800 ${tpl ? 76 : 84}px 'Plus Jakarta Sans', sans-serif`;
  wrapLines(ctx, headline, 920).slice(0, 3).forEach((l) => { ctx.fillText(l, W / 2, y); y += tpl ? 90 : 100; });
  if (bullets.length) {
    y += 10; ctx.font = "600 40px 'DM Sans', sans-serif"; ctx.fillStyle = "#ffffffe6";
    bullets.slice(0, 3).forEach((b) => { ctx.fillText(fit(ctx, `✓  ${b}`, 940), W / 2, y); y += 58; });
  }
  y += 40;
  const footer = H - 330;
  const Q = Math.max(320, Math.min(600, footer - y - 80)), qx = W / 2 - Q / 2 - 40;
  ctx.fillStyle = "#fff"; rr(ctx, qx, y, Q + 80, Q + 80, 44);
  const qr = await svgImg(qrSvg);
  if (qr) ctx.drawImage(qr, qx + 40, y + 40, Q, Q);
  ctx.fillStyle = "#fff"; ctx.font = "600 44px 'DM Sans', sans-serif";
  ctx.fillText("Kameranızla okutun, formu doldurun", W / 2, H - 250);
  ctx.font = "800 54px 'Plus Jakarta Sans', sans-serif"; ctx.fillText(fit(ctx, f.name || "", 960), W / 2, H - 140);
  ctx.font = "500 40px 'DM Sans', sans-serif"; ctx.fillStyle = "#ffffffd9";
  const sub = [f.title, f.phone].filter(Boolean).join("  ·  ");
  if (sub) ctx.fillText(fit(ctx, sub, 960), W / 2, H - 74);
  return new Promise((res) => c.toBlob(res, "image/png"));
}

export async function shareCard(blob, text, name = "kartvizit.png") {
  const file = new File([blob], name, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share({ files: [file], text }); return "shared"; } catch (e) { if (e?.name === "AbortError") return "cancelled"; }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
  return "downloaded";
}
